/**
 * Google Drive Authentication Service
 * Provides methods to trigger Google Drive OAuth flow directly
 */

/**
 * Start Google Drive authentication flow
 * Redirects user to Google OAuth page
 */
export const startGoogleDriveAuth = () => {
  const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
  const isClientIdConfigured = GOOGLE_CLIENT_ID && 
    GOOGLE_CLIENT_ID !== 'your-google-client-id' && 
    GOOGLE_CLIENT_ID.includes('.apps.googleusercontent.com')

  if (!isClientIdConfigured) {
    console.error('Google Client ID not configured')
    throw new Error('Google Drive is not configured. Please contact support.')
  }

  const SCOPES = [
    'https://www.googleapis.com/auth/drive',  // Full Google Drive access
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
  ].join(' ')

  // Build OAuth URL
  const clientId = GOOGLE_CLIENT_ID
  const redirectUri = `${window.location.origin}/auth/google/callback`
  const scope = SCOPES

  console.log('🔄 GoogleDriveAuth: Starting OAuth flow for reconnection...')
  console.log('- Client ID:', clientId?.substring(0, 20) + '...')
  console.log('- Redirect URI:', redirectUri)

  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
    `client_id=${encodeURIComponent(clientId)}&` +
    `redirect_uri=${encodeURIComponent(redirectUri)}&` +
    `scope=${encodeURIComponent(scope)}&` +
    `response_type=code&` +
    `access_type=offline&` +
    `prompt=consent&` +
    `state=${encodeURIComponent(window.location.pathname || '/notes')}`

  console.log('🔄 GoogleDriveAuth: Redirecting to Google OAuth...')

  // Store a flag to know this is a reconnection attempt
  sessionStorage.setItem('googleDriveReconnection', 'true')

  // Redirect to Google OAuth
  window.location.href = authUrl
}

/**
 * Check if current navigation is from a Google Drive reconnection
 */
export const isGoogleDriveReconnection = () => {
  return sessionStorage.getItem('googleDriveReconnection') === 'true'
}

/**
 * Clear the reconnection flag
 */
export const clearReconnectionFlag = () => {
  sessionStorage.removeItem('googleDriveReconnection')
} 